var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"crm-outline-wrapper"},[_c('img',{attrs:{"alt":"Your Free Trial is Building","src":require("../../assets/free-trial-build-page.png")}})])])
}]

export { render, staticRenderFns }